const validationError = {
    required: val => '欄位不可為空',
    email: val => 'Email 格式不正確',
    phone: val => '手機號碼格式不正確',
    numeric: val => '請輸入 0~9',
    confirmed: val => '請再次確認',
    min: val => `最小字數為${val}`,
    max: val => `最大長度為${val}`,
    password: val =>`密碼長度為 8 ~ 20 碼且需至少有一個大小寫英文、一個數字`
}

class Validator {
    constructor(target, rule, ruleMethod = {}) {
        this.target = target
        this._rules = rule
        this._errors = []
        this._messages = {}
        let _ruleMethod = {
            nullable(target, prop, val) {
                console.log(target, prop)
                console.log(target[prop])
                return !target.hasOwnProperty(prop) || !target[prop] || target[prop] === '';

            },
            required(target, prop, val) {
                console.log('required')
                console.log(target, prop)
                return !(!target.hasOwnProperty(prop) || !target[prop] || target[prop] === '');

            },
            email(target, prop, val) {
                if (!target.hasOwnProperty(prop)) {
                    return false
                }

                console.log('email')
                console.log(target, prop)
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(target[prop]);
            },
            numeric(target, prop, val){
                if (!target.hasOwnProperty(prop)) {
                    return false
                }


                const re = /^\d*$/;
                return re.test(target[prop]);
            },
            phone(target, prop, val){
                if (!target.hasOwnProperty(prop)) {
                    return false
                }


                const re = /^\d{10}$/;
                return re.test(target[prop]);
            },
            password(target, prop, val) {

                const re = /(?=.*\d)(?=.*[a-zA-Z]).{8,20}/
                return re.test(target[prop])
            },
            min(target, prop, val) {
                if (!target.hasOwnProperty(prop)) {
                    return false
                }
                return target[prop].length >= val
            },
            max(target, prop, val) {
                if (!target.hasOwnProperty(prop)) {
                    return false
                }
                return target[prop].length <= val
            },
            confirmed(target, prop, val) {
                console.log(target, prop)
                if (!target.hasOwnProperty(prop)) {
                    return false
                }
                let prop_confirm = `${prop}_confirmation`;
                if (target.hasOwnProperty(prop_confirm)) {
                    return target[prop] === target[prop_confirm]
                }
                return false
            }
        }
        this._ruleMethod = Object.assign(_ruleMethod, ruleMethod)
    }


    fails() {

        const that = this
        that._errors = []

        console.log(that.target)

        for (let prop in this._rules) {

            let nullable = false
            if (this._rules[prop].find(o => o === 'nullable')) {
                nullable = that._ruleMethod['nullable'].call(that, that.target, prop, null);
            }
            console.log(prop, nullable)
            for (let rule of this._rules[prop]) {
                let [ruleName, val = null] = rule.split(':')

                console.log(ruleName, val)
                if (ruleName === 'nullable') {
                    continue
                }
                if (!nullable && that._ruleMethod.hasOwnProperty(ruleName)) {
                    if (!that._ruleMethod[ruleName].call(that, that.target, prop, val)) {
                        that._errors.push({prop: prop, rule: ruleName, val: val})
                    }
                }
            }
        }
        return that._errors.length > 0
    }

    messages(messages = {}) {
        const that = this
        that._messages = messages
    }

    errors() {
        const that = this
        let out = {}
        for (let error of this._errors) {
            console.log(error)
            if (!out.hasOwnProperty(error.prop)) {
                out[error.prop] = []
            }
            let msg = '資料驗證錯誤'
            if (validationError.hasOwnProperty(error.rule)) {
                msg = validationError[error.rule].call(that, error.val)
            }
            if (that._messages.hasOwnProperty(error.prop) && that._messages[error.prop].hasOwnProperty(error.rule)) {
                msg = that._messages[error.prop][error.rule]
            }
            out[error.prop].push(msg)
            // let newError = {}
            // newError[error.rule] = msg
            // out[error.prop] = Object.assign(out[error.prop], newError)


        }
        return out
    }


}


export default {
    make(target, rule, ruleMethod = {}) {
        return new Validator(target, rule, ruleMethod)
    }
}
